<template>
  <roe-plan-design-edit-form
    :designs="designs"
    name="Auto Enrollment"
    :view-input="autoEnrollment"
    :form="$v.editableDesign"
  >
    <div class="right-panel-form-row-wrap">
      <div class="right-panel-label-wrap">
        <div class="light-label">Does the plan use Auto-Enrollment?</div>
      </div>
      <div class="right-panel-form-row">
        <div class="form-unit">
          <roe-auto-enrollment-select
            :design="$v.editableDesign"
          ></roe-auto-enrollment-select>
        </div>
      </div>
      <template v-if="showAutoEnrollment(editableDesign)">
        <template v-if="showAutoEnrollmentPriorEmployees(editableDesign)">
          <div class="right-panel-label-wrap">
            <div class="light-label">Applies to Prior Employees</div>
          </div>
          <div class="right-panel-form-row-wrap">
            <roe-auto-enrollment-applies-prior-employees-radio
              :design="$v.editableDesign"
            ></roe-auto-enrollment-applies-prior-employees-radio>
          </div>
        </template>
        <div class="right-panel-label-wrap">
          <div class="light-label">Auto-Enrollment Initial Percentage</div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-auto-enrollment-initial-percent-input
              :design="$v.editableDesign"
            ></roe-auto-enrollment-initial-percent-input>
          </div>
        </div>
        <div class="right-panel-label-wrap">
          <div class="light-label">Auto-Enrollment Contribution Type</div>
        </div>
        <div class="right-panel-form-row-wrap">
          <roe-auto-enrollment-contribution-type-radio
            :design="$v.editableDesign"
          ></roe-auto-enrollment-contribution-type-radio>
        </div>
      </template>
    </div>

    <template v-slot:survey>
      <roe-survey-bar label="None" :percent="survey.auto_enrollment.none"></roe-survey-bar>
      <roe-survey-bar label="New Hires" :percent="survey.auto_enrollment.new_hires"></roe-survey-bar>
      <roe-survey-bar label="All Employees" :percent="survey.auto_enrollment.all_employees"></roe-survey-bar>
      <roe-survey-bar label="1%" :percent="survey.auto_enrollment.percent1"></roe-survey-bar>
      <roe-survey-bar label="2%" :percent="survey.auto_enrollment.percent2"></roe-survey-bar>
      <roe-survey-bar label="3%" :percent="survey.auto_enrollment.percent3"></roe-survey-bar>
      <roe-survey-bar label="4%" :percent="survey.auto_enrollment.percent4"></roe-survey-bar>
      <roe-survey-bar label="5%" :percent="survey.auto_enrollment.percent5"></roe-survey-bar>
      <roe-survey-bar label="6%" :percent="survey.auto_enrollment.percent6"></roe-survey-bar>
      <roe-survey-bar label="7%" :percent="survey.auto_enrollment.percent7"></roe-survey-bar>
      <roe-survey-bar label="8%" :percent="survey.auto_enrollment.percent8"></roe-survey-bar>
      <roe-survey-bar label="8% +" :percent="survey.auto_enrollment.percent8plus"></roe-survey-bar>
    </template>
  </roe-plan-design-edit-form>
</template>

<script>
import RoePlanDesignEditForm from "@/components/alternative-designs/_shared/EditForm";
import RoeSurveyBarLight from "@/components/charts/SurveyBarLight";
import RoeSurveyBar from "@/components/charts/SurveyBar";
import { mapGetters } from "vuex";
import {
  RoeAutoEnrollmentSelect,
  RoeAutoEnrollmentEffectiveDateInput,
  RoeAutoEnrollmentInitialPercentInput,
  RoeAutoEnrollmentContributionTypeRadio,
  RoeAutoEnrollmentAppliesPriorEmployeesRadio
} from "@/components/_shared/inputs/design/auto-enrollment";

import { AutoEnrollmentMixin } from "@/components/_shared/inputs/design/_mixins";

export default {
  name: "RoeAutoEnrollment",
  components: {
    RoeAutoEnrollmentAppliesPriorEmployeesRadio,
    RoeAutoEnrollmentContributionTypeRadio,
    RoeAutoEnrollmentInitialPercentInput,
    RoeAutoEnrollmentEffectiveDateInput,
    RoeAutoEnrollmentSelect,
    RoeSurveyBar,
    RoeSurveyBarLight,
    RoePlanDesignEditForm
  },
  mixins: [AutoEnrollmentMixin],
  props: {
    designs: {
      type: Array,
      required: true
    }
  },
  validations() {
    return {
      editableDesign: this.validations
    };
  },
  computed: {
    ...mapGetters(["editableDesign", "autoEnrollment", "originalDesign", "survey"]),
    validations() {
      let validations = this.autoEnrollmentValidations(this.editableDesign);
      delete validations.effective_date_autoenroll;
      return validations;
    }
  }
};
</script>
